'use strict';

DoohApps.service('SessionHelper', [
    function SessionHelper() {
        var _this = this;
        this.setUserCredentials = function (data) {
            localStorage['TimeZone'] = data.timeZone;
            localStorage['DateFormat'] = data.dateFormat;
            var indexOfTime = data.dateFormat.indexOf('H');
            if (indexOfTime == -1) indexOfTime = data.dateFormat.indexOf('h');
            localStorage['ShortDateFormat'] = data.dateFormat
                .substring(0, indexOfTime)
                .trim();
            localStorage['TimeFormat'] = data.dateFormat.substring(
                indexOfTime,
                data.dateFormat.length
            );
            localStorage['TimeZoneIANA'] = data.timeZoneIANA;
        };

        this.setAccessToken = function (accessToken, expires) {
            localStorage['accessToken'] = accessToken;
            localStorage['expires'] = new Date(expires);
        };

        this.setRefreshToken = function (refreshToken) {
            localStorage['refreshToken'] = refreshToken;
        };

        this.clearAccessToken = function () {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('tokenUpdateInProgress');
        };

        //clear local storage entries that should not be preserved between logins/logouts
        this.clearSessionLocalStorage = function () {
            //credentials and similiar
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('tokenUpdateInProgress');
            localStorage.removeItem('expires');

            //asset selector
            localStorage.removeItem('assetSelectorOffset');
            localStorage.removeItem('assetSelectorPage');
            localStorage.removeItem('assetSelectorPath');
            _this.setUserCompany();
        }

        this.GetAccessToken = function () {
            return localStorage['accessToken'];
        };

        this.setUserCompany = function (company) {
            if (company === undefined || company.id === undefined)
                company = null;
            sessionStorage.setItem('userCompany', JSON.stringify(company));
        }
        this.getUserCompany = function () {
            return JSON.parse(sessionStorage.getItem('userCompany'));
        }
    }]);
